import { render } from "./CardVendasClass.vue?vue&type=template&id=bb2cf9ca"
import script from "./CardVendasClass.vue?vue&type=script&lang=js"
export * from "./CardVendasClass.vue?vue&type=script&lang=js"

import "./CardVendasClass.vue?vue&type=style&index=0&id=bb2cf9ca&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__